import { UI_RichText } from 'ui/components/1-atoms/RichText/RichText';
import styles from './DetailCard.module.scss';
import { UI_LinkButton } from 'ui/components/1-atoms/Action/LinkButton/LinkButton';
import { UI_Container } from 'ui/components/4-habitats/Container/Container';

export interface DetailCardProps {
	items: {
		heading: string;
		text: string;
	}[];
	cta?: {
		url: string;
		target: string;
		name: string;
	};
}

export const UI_DetailCard = ({ items, cta }: DetailCardProps) => {
	return (
		<div className={styles.DetailCard}>
			<UI_Container className={styles.DetailCard_container} width="Standard">
				<div className={styles.DetailCard_textWrapper}>
					{items?.map((item, index) => {
						if (!item) return null;
						return item?.text ? (
							<div className={styles.DetailCard_item} key={index}>
								<p className={styles.DetailCard_itemHeading}>{item.heading}</p>
								<UI_RichText content={item.text} />
							</div>
						) : null;
					})}
				</div>
				{cta && cta.url && (
					<div className={styles.DetailCard_ctaWrapper}>
						<UI_LinkButton className={styles.DetailCard_cta} url={cta.url} target={cta.target} style="primary">
							{cta.name}
						</UI_LinkButton>
					</div>
				)}
			</UI_Container>
		</div>
	);
};
